<template>

  <div class="flex flex-col w-full bg-blue-200 h-screen">

    <ring-loader v-if="showLoader"></ring-loader>

    <div v-if="brandInfo != null">

        <div class="flex justify-center items-center mt-10 mb-10 w-full px-2 lg:pl-20">

        <label class="mr-5"><strong>{{$t('brand.brandPicture')}} </strong></label>

        <img v-if="brandInfo.logo != ''" :src="brandInfo.logo" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
        <img v-else src="@/assets/images/full-logo.jpg" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
    </div>


      <div class="flex justify-center items-center mt-10 mb-10 w-full">
                      
            <label class="mr-5"><strong>{{$t('business.brandName')}} </strong></label>

            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{brandInfo.name}}</label>
      </div>
      
      <div class="flex justify-center items-center mt-10 mb-10 w-full">

        <label class="mr-5"><strong>{{$t('business.categories')}} </strong></label>

        <label class="mr-5 text-left text-blue-400"><strong v-for="(item,i) in brandInfo.brand_to_brand_categories" :key="i"> ({{i + 1}}) {{item.brand_category.name}} <br> </strong></label>

      </div>

      <div class="flex justify-center items-center mb-10 w-full">
                    
        <label class="mr-5"><strong>{{$t('profile.phone')}}  </strong></label>

        <label
        class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
        {{brandInfo.phone}}</label>
        </div>
      

        <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                      
            <label class="mr-5"><strong>{{$t('classes.description')}}  </strong></label>

            <p
            class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{brandInfo.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>

import myQueries from '../hasura/myQueries';

import componentsHelpers from '../classes/componentHelpers';


export default {

  props: {

    // brandInfo: {

    //     type: Object,
    //     default: () => ({}) 
    // },

    instructorId: 0,

    userId: 0,

    showInfoMethod: {

        type: Function
    }
  },
  components: {

  },

  async mounted(){

      // console.log(`instructorId: ${this.instructorId}`);

      const apollo = this.$apollo;

      const toasted = this.$toasted;

      let userId = this.userId;

      const t = this.$t;
      
      try{

            this.showLoader = true;

            let instructorResult = await this.$apollo.query({
            query: myQueries.one_instructor_query,

            variables:{

                instructorId: this.instructorId
            },

            error(error){
                
                this.showLoader = false;
                componentsHelpers.sendError(apollo, userId,'Sessions', 'classInstructor', 'mounted - catch 1', error);

                componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

            //   this.tokenError = JSON.stringify(error);
            },   
        });

      // console.log(`instructorResult: ${JSON.stringify(instructorResult)}`);

        if(instructorResult.data.brand != null){

            if(instructorResult.data.brand.length > 0){

                this.brandInfo = instructorResult.data.brand[0];
            }
        }

        this.showLoader = false;

      }catch(error){

            this.showLoader = false;
            componentsHelpers.sendError(apollo, userId,'Sessions', 'classInstructor', 'mounted - catch 2', error);

            componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
      }

      this.showLoader = false;

    },
  methods: {



  },

  computed: {


  },

  data:()=> {

    return {


      showLoader: false,

      brandName: '',

      brandInfo: null,
    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>